import { useAppDispatch, useAppSelector } from '@hooks/redux';
import { showAntifrodModalAC } from '@store/reducers/app';
import { Button, Checkbox, Modal } from 'antd';
import { KeyRound, Laptop, Link2Off, ShieldCheck } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ICON_SIZE = 24;
export const ANTIFROD_HIDE_KEY = 'hideAntifrodModal';

const items = [
  {
    icon: KeyRound,
    title: 'Коды подтверждения по SMS или Google Auth (OTP)',
    text: 'Никогда не передавайте сторонним лицам одноразовые коды. Сотрудники банка никогда не запрашивают такие сведения!',
  },
  {
    icon: Laptop,
    title: 'Программы удаленного управления',
    text: 'Если неизвестные требуют от вас установить AnyDesk, TeamViewer или RustDesk под любым предлогом — срочно прекратите беседу.',
  },
  {
    icon: Link2Off,
    title: 'Подозрительные интернет-ссылки (Фишинг)',
    text: 'Входите в личный кабинет только через официальный портал Ориёнбанка. Остерегайтесь поддельных ссылок.',
  },
];

const AntifrodModal = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const showAntifrodModal = useAppSelector(state => state.appReducer.showAntifrodModal);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleClose = () => {
    if (dontShowAgain) {
      localStorage.setItem(ANTIFROD_HIDE_KEY, '1');
    }
    dispatch(showAntifrodModalAC(false));
  };

  const handleDetails = () => {
    handleClose();
    navigate('/security');
  };

  return (
    <Modal width={560} footer={null} centered open={showAntifrodModal} onOk={handleClose} onCancel={handleClose}>
      <div className='px-2 pt-2 pb-1'>
        <div className='flex items-center gap-4 mb-6'>
          <div className='flex items-center justify-center w-12 h-12 rounded-full bg-amber-50 shrink-0'>
            <ShieldCheck size={26} className='text-amber-500' />
          </div>
          <div className='min-w-0'>
            <p className='text-lg font-semibold leading-tight text-gray-900'>Внимание! Рекомендации по безопасности</p>
            <p className='text-base text-gray-500 mt-1'>Для защиты ваших средств от интернет-мошенников</p>
          </div>
        </div>

        <div className='h-px bg-gray-100 mb-5' />

        <div className='flex flex-col gap-5'>
          {items.map(({ icon: Icon, title, text }) => (
            <div key={title} className='flex gap-4'>
              <div className='flex items-center justify-center w-10 h-10 rounded-lg bg-gray-50 shrink-0'>
                <Icon size={ICON_SIZE} className='text-gray-700' />
              </div>
              <div className='min-w-0'>
                <p className='text-base font-semibold text-gray-900 leading-snug'>{title}</p>
                <p className='text-sm text-gray-900 mt-1 leading-relaxed'>{text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className='mt-2 pt-5 border-t border-gray-100'>
          <Checkbox
            checked={dontShowAgain}
            onChange={e => setDontShowAgain(e.target.checked)}
            className='text-sm text-gray-600'
          >
            Больше не показывать
          </Checkbox>

          <div className='flex justify-end gap-2 mt-7'>
            <Button size='large' className='w-full' onClick={handleDetails}>
              Подробнее
            </Button>
            <Button size='large' className='w-full' type='primary' onClick={handleClose}>
              Понятно
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AntifrodModal;
